export var scorecardData = [
  {pillar:"Variable Ops & Sales",weight:25,metrics:[
    {name:"Gross Profit PVR — New",bench:"<$1,200 · $1,200–$1,800 · >$1,800"},
    {name:"Gross Profit PVR — Used",bench:"<$1,500 · $1,500–$2,200 · >$2,200"},
    {name:"Used-to-New Sales Ratio",bench:"<0.8:1 · 0.8–1:1 · >1:1"},
    {name:"Internet & Inbound Closing %",bench:"<10% · 10–18% · >18%"},
    {name:"Days Supply — New Inventory",bench:">90d · 60–90d · <60d"},
    {name:"Days Supply — Used Inventory",bench:">60d · 45–60d · <45d"},
    {name:"Untouched 3-Day Web Leads",bench:">5 leads · 1–5 leads · 0 leads"},
    {name:"Sales Team Avg Calls/Day",bench:"<30 · 30–50 · >50 calls"},
    {name:"SM Outbound Calls — L5D Leads",bench:"<15 · 15–30 · >30 calls"},
    {name:"SM Lost Lead Bucket Review",bench:"No process · Ad hoc · Daily formal"},
    {name:"Save-a-Deal Meeting",bench:"Never · Weekly · Daily"},
    {name:"SM Early T.O. on Deals",bench:"Never · Sometimes · Every deal"},
    {name:"Silent Trade Walk",bench:"Never · Weekly · Daily"},
    {name:"Internet Lead Response Time",bench:">2hr · 30–120min · <30min"},
  ]},
  {pillar:"F&I",weight:20,metrics:[
    {name:"F&I Per Retail Unit (PRU)",bench:"<$1,200 · $1,200–$2,457 · >$2,457"},
    {name:"VSC Penetration Rate",bench:"<30% · 30–70% · >70%"},
    {name:"Overall F&I Penetration",bench:"<50% · 50–70% · >70%"},
    {name:"CST Interview Before Box",bench:"Never · Sometimes · Always"},
    {name:"EWYK — F&I Floor Closing",bench:"No process · Ad hoc · Systematic"},
    {name:"100% Products 100% of Time",bench:"Not followed · Partial · Always"},
    {name:"VSC on Cash Deals",bench:"<10% · 10–30% · >30%"},
    {name:"Avg Time in Box",bench:">90min · 45–90min · <45min"},
    {name:"CIT — Contracts in Transit",bench:">10 days · 5–10 days · <5 days"},
  ]},
  {pillar:"Fixed Ops",weight:25,metrics:[
    {name:"Labor Gross Margin",bench:"<60% · 60–70% · >70%"},
    {name:"Parts Gross Margin",bench:"<30% · 30–40% · >40%"},
    {name:"Service Absorption Rate",bench:"<65% · 65–80% · >80%"},
    {name:"Effective Labor Rate (ELR)",bench:"<$85 · $85–$125 · >$125"},
    {name:"Obsolescence — Parts",bench:">$15K · $10–15K · <$10K"},
    {name:"Recon Turnaround Time",bench:">96hr · 72–96hr · <72hr"},
    {name:"Recon Charged at Retail",bench:"Never · Sometimes · Always"},
    {name:"Video Diagnosis Used",bench:"Never · Sometimes · Consistently"},
    {name:"Service Financing (Sunbit)",bench:"Not offered · Available · Actively sold"},
    {name:"Warranty Rate Increase — Submitted",bench:"Never · >12mo ago · Within 12mo"},
    {name:"Appointment Show Rate",bench:"<65% · 65–82% · >82%"},
    {name:"Net-to-Gross %",bench:"<20% · 20–35% · >35%"},
  ]},
  {pillar:"Back Office",weight:15,metrics:[
    {name:"Rebate Receivables >30 Days",bench:">$10K · $5–10K · None"},
    {name:"Warranty Receivables >30 Days",bench:">$5K · $1–5K · None"},
    {name:"Payables Processed",bench:"Monthly · Bi-weekly · Twice monthly"},
    {name:"Same-Day Billing",bench:"<70% · 70–90% · >90%"},
    {name:"Payroll as % of Gross",bench:">55% · 40–55% · <40%"},
    {name:"Floor Plan as % of Gross",bench:">4% · 2–4% · <2%"},
  ]},
  {pillar:"BDC, Marketing & Technology",weight:15,metrics:[
    {name:"QR Code Google Review Process",bench:"None · In place · Actively used"},
    {name:"Email Collection Rate",bench:"<60% · 60–80% · >80%"},
    {name:"After-Hours Responder",bench:"None · Basic · Full coverage"},
    {name:"Chatbot on Website",bench:"None · Basic · AI-powered"},
    {name:"Trade-In Tool on Website",bench:"None · Available · Promoted"},
    {name:"Inbound Call Protocol",bench:"No script · Partial · Full script"},
    {name:"CO-OP Process",bench:"No process · Ad hoc · Fully managed"},
    {name:"Manager-Confirmed Appointments",bench:"<50% · 50–80% · >80%"},
  ]},
];
